// extracted by mini-css-extract-plugin
module.exports = {"row":"style_row_dppS0","file":"style_file_1agFk"};